module.exports = __webpack_public_path__ + "img/w45.a978cef6.svg";